import React from "react";
import cx from "classnames";
import { Icon, Button, color } from "@wf/components";
import { useMediaQuery } from "react-responsive";
import { mobileLandscapeMaxWidth, tabletLandscapeMaxWidth } from "../../../../constants/viewports";
import MainContainer from "../MainContainer";
import UserBar from "../UserBar";
import LanguageBar from "../LanguageBar";
import NavBar from "../NavBar";
import { THandleLinkClick } from "../../../../helpers";
import useScrollDirection, { SCROLL_DIRECTION } from "../../hooks/useScrollDirection";
import styles from "./Header.module.scss";

interface HeaderProps {
  className?: string;
  children?: React.ReactNode;
  secondaryLogo: string;
  mainLogo: string;
  onMobileMenuClick: () => void;
  homeUrl?: string;
  handleLinkClick?: THandleLinkClick
  sidebarIsOpened?: boolean;
}

const Header: React.FC<HeaderProps> = ({
   className = "",
   children = null,
   homeUrl = "/",
   handleLinkClick = () => {},
   sidebarIsOpened = false,
   secondaryLogo,
   mainLogo,
   onMobileMenuClick,
 }) => {
  let userBar = null;
  let languageBar = null;
  let navBar = null;

  React.Children.forEach(children, child => {
    // @ts-ignore
    if (child?.type === UserBar) {
      userBar = child;
    }
    // @ts-ignore
    if (child?.type === LanguageBar) {
      languageBar = child;
    }
    // @ts-ignore
    if (child?.type === NavBar) {
      navBar = child;
    }
  });

  const isMobile = useMediaQuery({ maxWidth: mobileLandscapeMaxWidth });
  const isDesktop = useMediaQuery({ minWidth: +tabletLandscapeMaxWidth + 1 });

  const scrollDirection = useScrollDirection();

  return (
    <header
      className={cx(className, styles.header, {
        [styles.hide]: scrollDirection === SCROLL_DIRECTION.down && !sidebarIsOpened
      })}
    >
      {!isMobile && (
        <div className={cx(styles.topBar, "wf-sidebar-ignore")}>
          <MainContainer className={styles.container}>
            {languageBar}
            {userBar}
          </MainContainer>
        </div>
      )}
      {(!sidebarIsOpened || isDesktop) && (
        <div className={styles.brand}>
          <MainContainer className={styles.container}>
            <a
              href={homeUrl}
              className={styles.mainLogo}
              onClick={event => handleLinkClick(event, homeUrl, "_self", true)}
            >
              <img src={mainLogo} alt="" />
            </a>
            {isDesktop && navBar}
            <div className={styles.secondaryLogoContainer}>
              {!isMobile && (
                <span className={styles.secondaryLogo}>
                  <img src={secondaryLogo} alt="" />
                </span>
              )}
              {!isDesktop && (
                <Button
                  type="button"
                  onClick={onMobileMenuClick}
                  //@ts-ignore
                  isSquare
                  ghost
                  className={cx(styles.burgerButton, "wf-sidebar-ignore")}
                >
                  {/*@ts-ignore*/}
                  <Icon className={styles.burgerBtn} name="ic_menu" color={color("typography")} size={24} />
                </Button>
              )}
            </div>
          </MainContainer>
        </div>
      )}
    </header>
  );
};

export default React.memo(Header);
